module.exports = __webpack_public_path__ + "media/images/illust/illust-secondlife-db465f4b3844368227bec4795ad79b60.svg";